import { TCollectionInfo } from "../bloc/collectionsSlice";

export interface CollectionDataResponse {
  utr: string;
  createdOn: string;
  pmtMode: string;
  customerName: string;
  txnAmt: number;
  vaId: string;
  txnStatus: string;
  prodId: string;
}

export const mapPayoutResponseToModel = (data: CollectionDataResponse[]) => {
  let collections: TCollectionInfo[] = [];
  data.forEach((d) => {
    collections.push({
      utr: d.utr,
      createdOn: d.createdOn,
      customer: d.customerName,
      amount: d.txnAmt,
      paymentSource: d.pmtMode,
      status: d.txnStatus,
      prodId: d.prodId,
    });
  });

  return collections;
};
